// DS-5361: the Zendesk messenger launcher renders at z-index ~999999 — above
// every portal surface — so it floats over any open bottom sheet and covers the
// primary CTA. Sheets hide it while open and restore it on close.
//
// Ref-counted rather than a single boolean because sheets overlap: the priming
// sheet closes while the completion sheet opens (TaskView's handlePrimingContinue),
// so a naive close → 'show' would un-hide the launcher underneath the sheet that
// just opened.
let openCount = 0;

// Guarded so the MFE harness (no host, no window.zE) and ad-blocked browsers
// silently no-op instead of throwing.
const setMessengerVisible = (visible: boolean) => {
    if (typeof window === 'undefined') return;
    const zE = (window as unknown as { zE?: (...args: unknown[]) => void }).zE;
    if (typeof zE !== 'function') return;
    zE('messenger', visible ? 'show' : 'hide');
};

export function acquireZendeskHide(): void {
    openCount += 1;
    if (openCount === 1) setMessengerVisible(false);
}

export function releaseZendeskHide(): void {
    if (openCount === 0) return;
    openCount -= 1;
    if (openCount === 0) setMessengerVisible(true);
}

// Test-only: module state outlives individual cases within a Vitest file.
export function __resetZendeskVisibility(): void {
    openCount = 0;
}
